import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import OfferEndingText from './OfferEndingText.jsx';
import translations from './translations.js';
import { futureDate } from './helpers.js';

const AVM_MAX = 1;

class AddedValueMessagesListing extends PureComponent {
  render() {
    let listView;
    const { props } = this;
    const offers = props.data;
    const visibleOffers = [];

    for (let i = 0; i < offers.length; i++) {
      if (offers[i].show) visibleOffers.push(offers[i]);
    }

    if (props.view === 'grid') {
      listView = (
        <li>
          <span className={'offer'}>
            {' '}
            {offers.length}
            {' '}
            {offers.length > 1
              ? translations.dealsAvailable : translations.onedealAvailable}
          </span>
        </li>
      );
    } else if (visibleOffers) {
      listView = (
        visibleOffers
          .slice(0, AVM_MAX)
          .map((avm, i) => (
            <li key={i}>
              <span className={'offer'}>
                {avm.title}
              </span>
              {new Date(avm.to) < futureDate() &&
              <OfferEndingText from={avm.from} to={avm.to} />}
            </li>
          ))
      );
    }

    if (visibleOffers.length >= 1) {
      return (
        <ul className={`simple product-offers product-offers-${props.view}`}>
          {listView}
          {props.view === 'list' && offers.length > 1 && (
            <li className={'more-deals'}>
              {
                offers.length === 2
                  ? `+ ${translations.moreDealSingle}`
                  : `+ ${offers.length - 1} ${translations.moreDealsMulti}`
              }
            </li>
          )}
        </ul>
      );
    } if (offers.length >= 1 && props.view === 'grid') {
      return (
        <ul className={'simple product-offers product-offers-grid'}>
          {listView}
        </ul>
      );
    }
    return null;
  }
}

AddedValueMessagesListing.propTypes = {
  view: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      from: PropTypes.string,
      to: PropTypes.string,
      show: PropTypes.bool
    })
  ).isRequired
};

AddedValueMessagesListing.displayName = 'AddedValueMessagesListing';

export default AddedValueMessagesListing;
